<template>
  <div>
    <v-app-bar app absolute color="white" class="nav-sticky" rounded elevation="4" :style="drawer === false ? 'height: 64px !important' : 'height: 100% !important' ">
      <v-row align="center" align-content="center" class="d-flex">
        <v-toolbar-title div class="index-title d-flex align-center col-10 col-sm-10 col-md-10 col-lg-4" @click="goIndex()">
          <img src="@/assets/apiIcon2.png" alt srcset width="50px"/>
          <v-divider :thickness="5" class="align-center justify-center ml-3" style="border-width: 1px !important" dark color="lightgrey" vertical length="2"></v-divider>
          <p class="title-nav">บริการประทับรับรองเวลาอิเล็กทรอนิกส์</p>
        </v-toolbar-title>

        <!-- web menu dashboard -->
        <div class="menu-nav col-2 col-sm-2 col-md-5 col-lg-5 d-flex" v-if="!mobile">
          <v-list-item router exact style="height: auto !important;" v-if="this.$store.state.logined && (accountActive && accountActive === 'true')">
            <v-list-item-title class="title-subNav" 
            :class="{'active-nav' : pathValue === menu.value}"
            v-for="(menu) in menuText"
            :key="menu.value" 
            @click="actionMenu(menu.value)">
            {{menu.text}}
            </v-list-item-title>
          </v-list-item>
        </div>
        <div class="menu-nav col-3 col-sm-3 col-md-3 col-lg-3 d-flex justify-end" v-if="!mobile">
          
          <!-- web menu -->
          <li class="user-warpper" v-ripple v-if="this.$store.state.logined && (accountActive && accountActive === 'true')">
            <v-menu bottom left offset-y class="col-11">
              <template v-slot:activator="{ on }">
                <v-list-item v-on="on" style="justify-content: center !important;">
                  <v-list-item-avatar size="30px">
                    <v-icon large color="#71B842">
                      mdi-account-circle
                    </v-icon>
                  </v-list-item-avatar>
                  <v-list-item-title class="font-size-14">{{username}}</v-list-item-title>
                  <v-icon>mdi-menu-down</v-icon>
                </v-list-item>
              </template>
              <v-list class="menu-dropdown" dense nav>
                <!-- <v-list-item style="color:#007aff !important;">
                  {{username}}
                </v-list-item> -->
                <v-list-item
                  v-for="(item, i) in menusUp"
                  :key="i"
                  @click="menuGoto(item)"
                >
                  <v-icon v-if="item.title === 'ออกจากระบบ'">mdi-logout</v-icon>
                  <v-icon v-if="item.title === 'Home Page'">mdi-home-circle</v-icon>
                  <!-- <v-icon v-if="item.title === 'Account'">mdi-card-account-details-outline</v-icon> -->
                  <v-list-item-title
                    class="font-size-14 pl-2 pt-1 pb-1"
                    size="30px">
                    {{ item.title }}
                    <!-- <v-icon>mdi-logout</v-icon> -->
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
            <div class="col-1"></div>
          </li>

          <div v-else class="user-warpper">
            <v-btn class="register-border" color="#6CB549" @click="login()" dense dark>เริ่มใช้บริการ
              <v-icon color="white" class="ml-1">mdi-login</v-icon>
            </v-btn>
          </div>
        </div>

        <!-- mobile menu dashboard-->
        <div v-if="mobile" class="col-2 nav-mobile-menu">
          <v-btn
            class="d-none d-sm-flex d-md-none d-flex d-sm-none toggle-btn"
            icon
            @click.stop="drawer = !drawer"
          >
            <v-icon>mdi-menu</v-icon>
          </v-btn>
          <v-navigation-drawer
            v-model="drawer"
            absolute
            temporary
            class="drawerNavbar super-menu-mobile-scroll"
            right
            light
            width="100%"
            height="1366"
          >
            <v-list-item class="mt-2 mb-1">
              <!-- <v-icon color="#63A038">mdi-format-list-bulleted-square</v-icon>
              <span class="menu-text">เมนู</span> -->
              <div class="d-flex" v-if="this.$store.state.logined && (accountActive)">
                <v-icon color="#63A038">mdi-account-circle</v-icon>
                <span class="menu-text" >{{username}}</span>
              </div>
              <div class="d-flex" @click="login()" v-else>
                <v-icon color="#63A038">mdi-account-circle</v-icon>
                <span class="menu-text" >ลงชื่อเข้าใช้</span>
              </div>
              <v-spacer />
              <a style="width: auto;">
                <v-icon @click.stop="drawer = !drawer">
                  mdi-close
                </v-icon>
              </a>
            </v-list-item>
            <v-divider />
            <br/>
            <!-- <v-list-item
              to="/dashboardTSA/account-user"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
              :disabled="accountActive === false"
            >
              <v-list-item-title>Account</v-list-item-title>
            </v-list-item> -->
            <v-list-item
              to="/"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
            >
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/dashboardTSA/"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
              :disabled="accountActive === 'false'"
            >
              <v-list-item-title>Dashboard TSA</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/dashboardTSA/Service"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
              :disabled="accountActive === 'false'"
            >
              <v-list-item-title>Service</v-list-item-title>
            </v-list-item>
            <v-list-item
              to="/dashboardTSA/Service"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
              :disabled="accountActive === 'false'"
            >
              <v-list-item-title>
                <!-- <v-icon class="user-warpper mr-3" color="#0097A7" size="28">mdi-message-star-outline</v-icon> -->
                แบบประเมินการใช้บริการ
              </v-list-item-title>
            </v-list-item>
            <!-- <v-list-item
              to="/dashboardTSA/detail-log"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
              :disabled="accountActive === 'false'"
            >
              <v-list-item-title>Detail Log</v-list-item-title>
            </v-list-item> -->
            <!-- <v-list-item
              to="/dashboardTSA/tsa-log"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
              :disabled="accountActive === 'false'"
            >
              <v-list-item-title>TSA Log</v-list-item-title>
            </v-list-item> -->
            <!-- <v-list-item
              to="/dashboardTSA/service-rate"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
            >
              <v-list-item-title>Service Rate</v-list-item-title> -->
            <!-- </v-list-item> -->
            <v-list-item
              to="/login"
              router
              exact
              style="height: auto !important;"
              class="text-left menu-hover"
            >
              <v-icon class="mr-3">mdi-logout</v-icon>
              <v-list-item-title>ออกจากระบบ</v-list-item-title>
            </v-list-item>
          </v-navigation-drawer>
        </div>
      </v-row>
    </v-app-bar>
    <div class="sub-nav-tsa" v-if="pathTitle !== 'ServiceTSA'">
      <v-container style="padding: 1rem;">
        <v-row v-if="!mobile" class="pt-1">
          <v-col cols="1"></v-col>
          <v-col cols="7" class="d-flex">
            <span class="title-sub-nav">
              <v-icon large class="mr-3" color="green">mdi-view-dashboard</v-icon>
              {{pathTitle}}
            </span>
          </v-col>
          <v-col cols="4"></v-col>
        </v-row>
        <v-row v-else>
          <v-col class="col-title-sub-nav">
            <span class="title-sub-nav">{{pathTitle}}</span>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div> 
</template>

<script>
export default {
  name: "App",
  data: () => ({
    title: "",
    accountActive: localStorage.getItem("active"),
    username: localStorage.getItem("username"),
    menusUp: [
      // { title: "Account", path: "/dashboardTSA/account-user", action: ""},
      { title: "Home Page", path: "/dashboard/", action: ""},
      { title: "ออกจากระบบ", path: "/login", action: "logout" }
    ],
    pathTitle: "",
    pathValue: '',
    menuText: [
      {text: 'Dashboard', value: 'DashboardTSA'},
      {text: 'Service', value: 'ServiceTSA'},
      {text: 'แบบประเมินการใช้บริการ', value: 'แบบประเมินการใช้บริการ'},
      // {text: 'Detail Log', value: 'DetailLog'},
      // {text: 'TSA Log', value: 'TSALog'}
      // {text: 'Service Rate', value: 'ServiceRateTSA'}
    ],
    mobile: window.innerWidth <= 959,
    drawer: false
  }),
  mounted () {
    this.accountActive = localStorage.getItem("active")
    this.$store.state.logined = localStorage.getItem('username') ? true : false
  },
  created () {
    addEventListener('resize', () => {
      this.mobile = innerWidth <= 959
    })
    this.pathTitle = this.$router.currentRoute.meta.title
    this.pathValue = this.$router.currentRoute.name
  },
  watch: {
    // $route (to, from, next) {
    $route (to) {
      // if (to.matched.some(record => record.meta.header)) {
      // console.log('to', to)
      // console.log(to)
      this.pathTitle = to.meta.title
      this.pathValue = to.name
      // }
    }
  },
  methods: {
    menuGoto(val) {
      this.$router.push(`${val.path}`);
    },  
    login () {
      this.$router.push("/login");
    },
    actionMenu (value) {
      if (value === 'ServiceTSA') this.$router.push("/dashboardTSA/Service");
      // else if (value === 'DetailLog') this.$router.push("/dashboardTSA/detail-log");
      else if (value === 'DashboardTSA') this.$router.push("/dashboardTSA/");
      else if (value === 'แบบประเมินการใช้บริการ') this.linktoCustomerSatisfactionSurvey();
      // else if (value === 'ServiceRateTSA') this.$router.push("/dashboardTSA/service-rate");
      // else this.$router.push("/dashboardTSA/tsa-log")
    },
    goIndex() {
      this.$router.push("/dashboard/");
    },
    linktoCustomerSatisfactionSurvey() {
      const accountID = localStorage.getItem("account_id")
      // const accountID = 4187974266883030
      const bizID = 794856770048
      // const redirectUrl = window.location.origin.includes('uat') ? 'https://uat-tsa.one.th/tsa_web/dashboardTSA/' : 'https://tsa.one.th/tsa_web/dashboardTSA/'
      if (window.location.origin.includes('uat')){
        const redirectUrl = 'https://uat-tsa.one.th/tsa_web/dashboardTSA/'
        window.open(`https://csat-survey-uat.inet.co.th/satisfaction/survey?shared_token=&account_id=${accountID}&biz_id=${bizID}&redirect_url=${redirectUrl}&service_id=863&role=user`, '_self')
      } else {
        const redirectUrl = 'https://tsa.one.th/tsa_web/dashboardTSA/'
        window.open(`https://csat-survey.inet.co.th/survey?shared_token=&account_id=${accountID}&biz_id=${bizID}&redirect_url=${redirectUrl}&service_id=863&role=user`, '_self')
      }
      
      
    }
  },
};
</script>

<style>
.user-warpper {
  /* margin-left:25px; */
  /* margin-right: 20px; */
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 50px;
  cursor: pointer;
}
.index-title {
  cursor: pointer;
}
.nav-sticky {
  /* height: 64px !important; */
  /* position: sticky !important; */
  overflow: hidden !important;
  position: fixed !important;
  top: 0 !important;
  z-index: 99 !important;
  background: url("../assets/bg-home.jpg") no-repeat,
  linear-gradient(180deg, rgb(255, 255, 255) 0%, #d6eec1 65%, #d6eec1 100%);
  background-position: top center;
  background-size: cover;
  background-blend-mode: soft-light;
  
}
.title-nav  {
  margin-bottom: 0 !important;
  margin-left: 5px !important;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.29px;
  text-align: center;
  color: #8e8e93;
  text-align: center;
  margin-bottom: 24px;
}
/* .menu-nav { */
  /* padding-left: 50px; */
  /* padding-right: 50px; */
/* } */
.title-subNav {
  margin-bottom: 0 !important;
  margin-left: 5px !important;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.29px;
  text-align: center;
  color: #0000008A;
  text-align: center;
  margin-bottom: 24px;
  cursor: pointer;
}
.sub-nav-tsa {
  width: 100%;
  display: flex;
  height: auto;
  position: fixed;
  top: 60px;
  left: 0;
  /* padding: 50px; */
  background-image: linear-gradient(to left, #D6EEC1, #D6EEC1 0%) !important;
  z-index: 2;
  justify-content: center;
}
.v-list-item__title.title-subNav:hover {
  color: #6CB549 !important;
  background-color: #F6FBF2;
  font-size: 16px;
  padding-top: 7px;
  padding-bottom: 7px;
  border-radius: 7px;
}

.active-nav {
  color: #6CB549 !important;
  /* background-color: #F6FBF2; */
  padding-top: 7px;
  padding-bottom: 7px;
  border-radius: 7px;
  font-weight: 500;
  font-size: 16px;
}

.register-border {
  padding: 6px 20px;
  border-radius: 2rem;
  background: #6CB549;
  color: #fff !important;
  border: 0;
  font-size: 16px;
  text-transform: uppercase;
  -webkit-box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
  cursor: pointer !important;
}
.title-sub-nav {
  color: green;
  font-size: 18px;
  font-weight: 500;
  /* margin: 0 0 0 -19px; */
}

.col-title-sub-nav {
  text-align: none;
}

@media screen and (max-width: 959px) {
  .nav-mobile-menu {
    text-align: -webkit-right;
    margin-top: -4px;
  }
  .title-nav {
    font-size: 11px;
  }
  .super-menu-mobile-scroll {
    background: #FFF;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0px 10px 0 10px
  }
  .toggle-btn {
    display: none;
    border: 0px;
    box-shadow: none !important;
  }
  .menu-text {
    padding-left: 0.8em;
    font-size: larger;
    display: flex;
    font-weight: 500;
    color: #6CB549;
    align-self: center;
  }
  .menu-hover:active {
    background: aliceblue !important;
    color: #2196f3 !important;
  }
  .menu-hover:hover {
    background: aliceblue !important;
    color: #2196f3 !important;
  }
}
</style>
